import { render, staticRenderFns } from "./IndexBankAccountsPage.vue?vue&type=template&id=09263034&"
import script from "./IndexBankAccountsPage.vue?vue&type=script&lang=js&"
export * from "./IndexBankAccountsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports